export var FETCH_BALANCE = 'FETCH_BALANCE';
export var SUCCESS_FETCH_BALANCE = 'SUCCESS_FETCH_BALANCE';
export var FAILURE_FETCH_BALANCE = 'FAILURE_FETCH_BALANCE';



// WEBPACK FOOTER //
// ./src/actions/balance.js